import { TRANSPARENCY_TYPES } from '../../utils/constants';
import {
    displayCurrencyOrDash,
    displayShortDateOrNA,
    formatWithCommasOrNA,
    displayPercent,
    displayPercentOrDash,
    DASH_DEFAULT
} from '../../utils/Format/Format';

export const marketDataUtil = (ticker) => (gqlResult) => {
    if (!gqlResult) return null;
    const {
        exchangeTradedFund: {
            inavTicker,
            averageAnnualTotalReturns: {
                quarterly: { asOfDate: quarterlyDate }
            },
            transparencyTypeName,
            price: {
                asOfDate: displayDate,
                navPrice,
                navPricePercentChange,
                closingPrice,
                closingPricePercentChange,
                premiumDiscountValuePercent,
                totalAssets,
                outstandingShares,
                dailyTradingVolumeShares
            }
        }
    } = gqlResult;

    const hideValueIfNewFund = !quarterlyDate;
    const asOfDate = displayShortDateOrNA(displayDate);

    const handleZeroDash = (val) => {
        if (val === 0) {
            return displayPercent(val);
        }
        return displayPercentOrDash(val);
    };

    const returnData = [
        {
            label: `NAV (%) changed`,
            values: [
                {
                    val1: hideValueIfNewFund
                        ? DASH_DEFAULT
                        : handleZeroDash(navPricePercentChange)
                }
            ]
        },
        {
            label: `NAV ($)`,
            values: [{ val1: displayCurrencyOrDash(navPrice) }]
        },
        {
            label: `iNAV`,
            values: [{ val1: inavTicker }]
        },
        {
            label: `Closing Market Price`,
            labelSubtitle: `as of ${asOfDate || 'N/A'}`,
            values: [
                {
                    val1:
                        closingPrice === 0
                            ? displayPercent(closingPrice)
                            : displayCurrencyOrDash(closingPrice)
                }
            ]
        },
        {
            label: `Closing Market Price % Change`,
            values: [
                {
                    val1: hideValueIfNewFund
                        ? DASH_DEFAULT
                        : handleZeroDash(closingPricePercentChange)
                }
            ]
        },
        {
            label: `Total Net Assets`,
            values: [{ val1: displayCurrencyOrDash(totalAssets) }]
        },
        {
            label: `Premium/Discount to NAV`,
            values: [
                {
                    val1: handleZeroDash(premiumDiscountValuePercent)
                }
            ],
            tipContent:
                'The amount (stated in dollars or percent) by which the selling or purchase market price of an ETF is greater than (Premium) or less than (Discount) its net asset value (NAV).'
        },
        {
            label: `Shares Outstanding`,
            values: [{ val1: `${formatWithCommasOrNA(outstandingShares)}` }],
            tipContent:
                'The shares outstanding of the fund are how many shares have been issued and can change daily with creations and redemptions.'
        }
    ];

    return {
        data:
            transparencyTypeName === TRANSPARENCY_TYPES.FULL
                ? [
                      ...returnData.filter((data) => data.label !== 'iNAV'),
                      {
                          label: `Daily Trading Volumes (Shares)`,
                          values: [
                              {
                                  val1: `${formatWithCommasOrNA(
                                      dailyTradingVolumeShares
                                  )}`
                              }
                          ]
                      }
                  ]
                : returnData,
        asOfDate,
        ticker
    };
};
